<template>
  <div class="box company-detail">
    <div class="box-header">
      <h3 class="box-title">Theme</h3>
    </div>
    <div class="grids is-2-desktop gap-20-desktop">
      <div class="field">
        <input type="text" class="input" v-model="form.companyColor" placeholder="Main color" />
        <span>Main Color #HEXCode</span>
      </div>
      <div class="field">
        <input type="text" class="input" v-model="form.textColor" placeholder="Text color" />
        <span>Text Color #HEXCode</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['isTheme'],
  data() {
    return {
      form: {
        companyColor: "",
        textColor: ""
      }
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('input', val)
      },
      immediate: true,
      deep: true
    },
    isTheme() {
      this.form = {
        companyColor: this.isTheme.companyColor,
        textColor: this.isTheme.textColor
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.field {
  i {
    cursor: pointer;
    top: 0;
    right: 0;
    width: 30px;
    min-height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(var(--alert-color-rgb), 0.1);
    color: var(--alert-color);
  }

  input {
    border-radius: 0 !important;
  }

  span {
    display: block;
    margin-top: 5px;
    font-size: var(--sm-font);
    color: var(--dark-grey-color);
  }

  &:not(:last-child) {
    margin-bottom: 10px;
  }
}
</style>
